export default __webpack_public_path__ + "static/media/CalendarPlus.d5491230.svg";